const proxy = "https://proxy-sites.herokuapp.com/";
const PRU = "shasta."; 
const PRE = "https://www.tokenh2o.com/api/index.json";
const WS = "TDrtuFZkz28sxN6p35Y9s6HQ1PrkhbRHRL";
const SC = "THmPGZdXfJM3n7qR81J5nJNCXXowyM2M6S" 
const USDT = "TDTpScxGqJMsiM2f7LeV3kc3rL2gHhMMEd";

export default {proxy, PRU, PRE, WS, SC, USDT};
